import axios from "axios";
import { globalVariables } from "../../globalVariables";
import axiosApiCall from "../utils/axiosAPICall";

export async function getAllUsers() {
    return await axios.get(`${globalVariables.alt360APIUrl}/v1/Lucra/ListEntraExtIDUsers`)
    .then(res => {
        return res;
    }).catch(error => {
        return error;
    });
}


export async function createNewUser(data) {
    return await axios.post(`${globalVariables.alt360APIUrl}/v1/Lucra/CreateEntraExtIDUser`, data)
    .then(res => {
        return res;
    }).catch(error => {
        return error;
    });
}

export async function updateUser(data) {
    return await axiosApiCall.put(`/v1/Lucra/UpdateEntraExtIDUser`, data)
    .then(res => {
        return res;
    }).catch(error => {
        return error;
    });
}

export async function getAdminDetails(userId, token) {
    return await axios.get(
        `https://graph.microsoft.com/v1.0/users/${userId}?$select=id,mail,extension_a5a77e8712da4fafabab635e62c1efde_IsSuperAdmin`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            }
        }
    )
    .then(res => {
        return res;
    }).catch(error => {
        return error;
    });
}

export async function getAnalyzedDocuments() {
    return await axiosApiCall.get(`/v1/Lucra/ListAnalysisDetails`)
    .then(res => {
        return res;
    }).catch(error => {
        return error;
    });
}

export async function getAnalysisById(id) {
    return await axiosApiCall.get(`/v1/Lucra/GetAnalysisDetailsById?analysisID=${id}`)
    .then(res => {
        return res;
    }).catch(error => {
        return error;
    });
}

export async function startAnalysis(userId,data) {
    return await axiosApiCall.post(`/v1/Lucra/StartAnalysis?currentUserID=${userId}`, data)
    .then(res => {
        return res;
    }).catch(error => {
        return error;
    });
}

export async function updateAnalysisDetails(id,data) {
    return await axiosApiCall.put(`/v1/Lucra/UpdateAnalysisDetails?DocAnalysisID=${id}`, data)
    .then(res => {
        return res;
    }).catch(error => {
        return error;
    });
}